import { render, staticRenderFns } from "./StarshipitUpload.vue?vue&type=template&id=4bc99cef&"
import script from "./StarshipitUpload.vue?vue&type=script&lang=js&"
export * from "./StarshipitUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports